'use client';

import { pageDirectories } from '@/constant/route';
import { SidebarItemProps, useSidebarStore } from '@/hooks/use-sidebar-store';
import { usePathname } from '@/navigation';
import { Home } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { CustomBreadcrumbResponsive } from '../../components/custom-breadcrumb';

type CustomHeaderBreadcrunm = {
    className?: string;
};

function findPathByPathname(
    tree: SidebarItemProps[],
    pathname: string
): SidebarItemProps[] {
    // Hàm tìm đường dẫn tới node có href khớp với pathname
    function searchPath(node: SidebarItemProps): SidebarItemProps[] | null {
        // Nếu node hiện tại có href khớp với pathname, trả về mảng chứa node này
        if (node.href === pathname) {
            return [node];
        }

        // Nếu node có children, duyệt qua từng node con
        if (node.children) {
            for (const child of node.children) {
                const path = searchPath(child);
                // Nếu tìm thấy đường dẫn trong cây con, trả về đường dẫn bao gồm node hiện tại
                if (path) {
                    return [node, ...path];
                }
            }
        }

        // Nếu không tìm thấy trong cây con, trả về null
        return null;
    }

    // Duyệt qua từng node trong cây gốc
    for (const node of tree) {
        const result = searchPath(node);
        // Nếu tìm thấy đường dẫn cho node này, trả về kết quả
        if (result) {
            return result;
        }
    }

    // Trả về [] nếu không tìm thấy pathname trong toàn bộ cây
    return [];
}

export function CustomHeaderBreadcrum(params: CustomHeaderBreadcrunm) {
    const pathname = usePathname();
    const transDef = useTranslations('System');
    const transAll = useTranslations();
    const [items, setItems] = useState<SidebarItemProps[]>([]);

    const menus = useSidebarStore((state) => state.menus);

    useEffect(() => {
        const filtered = findPathByPathname(menus, pathname);

        let values: SidebarItemProps[] = [
            {
                name: transDef('System_Home'),
                key: '-1',
                href: pageDirectories.Home,
                icon: {
                    component: Home,
                    className: 'w-5 h-5',
                },
                _showIcon: true,
            },
        ];

        values = createMockupBreadcrum(values, pathname, transAll);

        if (filtered) {
            values = values.concat(filtered);
        }

        setItems(values);
    }, [transDef, menus, pathname, transAll]);

    return <CustomBreadcrumbResponsive {...params} items={items} />;
}

/**
 * Một số breadcrum sẽ mockup ở FE
 */
function createMockupBreadcrum(
    breadcrums: SidebarItemProps[],
    pathname: string,
    t: any
): SidebarItemProps[] {
    let values = [...breadcrums];

    if (pathname === pageDirectories.ProfileInfo) {
        values.push({
            name: t('AccountInfo.AccountInfo_AccountInfo'),
            key: '-2',
            href: pageDirectories.ProfileInfo,
            _showIcon: false,
        });
    } else if (
        pathname === pageDirectories['DossierDetail'] ||
        pathname.startsWith(pageDirectories['DossierDetail'])
    ) {
        values.push({
            name: t('DossierManagement.DossierManagement_DossierDetail'),
            key: '-2',
            href: pathname,
            _showIcon: false,
        });
    } else if (
        pathname === pageDirectories['DossierProcessing'] ||
        pathname.startsWith(pageDirectories['DossierProcessing'])
    ) {
        values.push({
            name: t('DossierManagement.DossierManagement_DossierProcessing'),
            key: '-2',
            href: pathname,
            _showIcon: false,
        });
    }

    return values;
}
